import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import './assets/styles/style.css'
import 'v-calendar/dist/style.css'
import { authDirectives } from '@/modules/auth/auth.directives'

const pinia = createPinia()
loadFonts()
createApp(App)
  .use(router)
  .use(pinia)
  .use(vuetify)
  .directive('auth', authDirectives)
  .mount('#app')
